import { render } from "./ViewerSheetGestures.vue?vue&type=template&id=172d5043&ts=true"
import script from "./ViewerSheetGestures.vue?vue&type=script&lang=ts"
export * from "./ViewerSheetGestures.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__